import { Icon } from '@chakra-ui/react';

export const TooltipIcon = ({ ...props }: any) => {
	return (
		<Icon
			w="15px"
			h="15px"
			viewBox="0 0 15 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8.075 10.9096C8.075 10.523 7.7616 10.2096 7.375 10.2096C6.9884 10.2096 6.675 10.523 6.675 10.9096H8.075ZM6.675 10.9167C6.675 11.3033 6.9884 11.6167 7.375 11.6167C7.7616 11.6167 8.075 11.3033 8.075 10.9167H6.675ZM6.675 8.79167C6.675 9.17827 6.9884 9.49167 7.375 9.49167C7.7616 9.49167 8.075 9.17827 8.075 8.79167H6.675ZM4.57414 5.19653C4.47348 5.56979 4.69447 5.95398 5.06774 6.05464C5.441 6.1553 5.8252 5.93431 5.92586 5.56105L4.57414 5.19653ZM6.675 10.9096V10.9167H8.075V10.9096H6.675ZM8.8 5.89394C8.8 6.21682 8.62149 6.39428 8.04316 6.78859C7.58073 7.10388 6.675 7.6558 6.675 8.79167H8.075C8.075 8.51087 8.23177 8.35445 8.83184 7.94531C9.31601 7.61519 10.2 7.05212 10.2 5.89394H8.8ZM7.375 4.53333C8.19715 4.53333 8.8 5.15866 8.8 5.89394H10.2C10.2 4.35313 8.93762 3.13333 7.375 3.13333V4.53333ZM5.92586 5.56105C6.07676 5.00148 6.66017 4.53333 7.375 4.53333V3.13333C6.07781 3.13333 4.90259 3.97859 4.57414 5.19653L5.92586 5.56105ZM13.05 7.375C13.05 10.5092 10.5092 13.05 7.375 13.05V14.45C11.2824 14.45 14.45 11.2824 14.45 7.375H13.05ZM7.375 13.05C4.24078 13.05 1.7 10.5092 1.7 7.375H0.3C0.3 11.2824 3.46759 14.45 7.375 14.45V13.05ZM1.7 7.375C1.7 4.24078 4.24078 1.7 7.375 1.7V0.3C3.46759 0.3 0.3 3.46759 0.3 7.375H1.7ZM7.375 1.7C10.5092 1.7 13.05 4.24078 13.05 7.375H14.45C14.45 3.46759 11.2824 0.3 7.375 0.3V1.7Z"
				fill="#9D9D9D"
			/>
		</Icon>
	);
};
